import PropTypes from 'prop-types';
import { memo } from 'react';

import useTemplates from '../../hooks/useTemplates';
import { useRecentColors } from '../colorPicker/useRecentColors';
import ConfirmationDialog from './ConfirmationDialog';

function TemplateDeleteDialog(props) {
  const { onClose, open, templateId } = props;
  const { deleteTemplate } = useTemplates();
  const { removeRecentColors } = useRecentColors();

  const handleConfirm = async () => {
    await deleteTemplate(templateId);
    removeRecentColors(templateId);
  };

  return (
    <ConfirmationDialog
      title="Delete Template?"
      text="You won't be able to recover it later."
      confirmButtonText="Delete"
      danger
      showCancel
      onConfirm={handleConfirm}
      onClose={onClose}
      open={open}
    />
  );
}

TemplateDeleteDialog.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  templateId: PropTypes.string,
};

export default memo(TemplateDeleteDialog);
